import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-02b82f1f")
const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-mt-0 p-mr-5" }, "Carga de SVGs", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mt-0 p-mb-2" }, "Opciones", -1)
const _hoisted_4 = ["for"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["href"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_FileUpload, {
        class: "ch-fileupload",
        name: "file",
        mode: "basic",
        accept: "image/svg+xml",
        chooseLabel: "Cargar SVG",
        customUpload: true,
        auto: true,
        onUploader: _ctx.onUpload,
        onUpload: _ctx.onUploaded
      }, null, 8, ["onUploader", "onUpload"])
    ]),
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processingOptions, (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.key,
        class: "p-mb-1"
      }, [
        _createVNode(_component_Checkbox, {
          id: option.key,
          modelValue: option.value,
          "onUpdate:modelValue": ($event: any) => (option.value = $event),
          binary: true
        }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]),
        _createElementVNode("label", {
          class: "p-ml-2",
          for: option.key
        }, _toDisplayString(option.label), 9, _hoisted_4)
      ]))
    }), 128)),
    (_ctx.uploadedSvgUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.uploadedSvgUrl,
            alt: "",
            class: "svg-container"
          }, null, 8, _hoisted_6),
          _hoisted_7,
          _createVNode(_component_Button, {
            label: "Copiar URL",
            class: "p-mr-3",
            onClick: _ctx.copyUrlToClipboard,
            icon: "pi pi-copy"
          }, null, 8, ["onClick"]),
          _createElementVNode("a", { href: _ctx.uploadedSvgUrl }, _toDisplayString(_ctx.uploadedSvgUrl), 9, _hoisted_8)
        ]))
      : _createCommentVNode("", true)
  ]))
}